window.addEventListener('load', function () {
    const slickList = document.querySelector('[id="custom-announcement-bar"] .slick-list');
      slickList?.addEventListener('click', function () {
      const activeSlide = document.querySelector('[id="custom-announcement-bar"] .slick-active');
      const link = activeSlide.querySelector('a.announcement-bar__content');
      link && link.click();
    });
  });
;
document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector('.header__drawer');
    const drawerOverlay = document.querySelector('.header__drawer__overlay');
    const drawerTrigger = document.querySelector('.custom-header__menu-trigger');
    const drawerCloseButton = document.querySelector('.header__drawer-close');
    const accordions = document.querySelectorAll('.header__drawer__menu-checkbox');
    const floatingKlavio = document.querySelectorAll('.needsclick.kl-teaser-WcYMKJ.undefined.kl-private-reset-css-Xuajs1');

    drawerTrigger.addEventListener('click', () => {
      drawer.classList.add('is-open');

      if (floatingKlavio) {
          floatingKlavio.classList.add('is-hidden');
      }
    });

    drawerOverlay.addEventListener('click', () => {
      drawer.classList.remove('is-open');
    });

    drawerCloseButton.addEventListener('click', () => {
      drawer.classList.remove('is-open');
    });

    accordions.forEach((accordion) => {
      accordion.addEventListener('change', function () {
        if (this.checked) {
          // Uncheck all other checkboxes
          accordions.forEach((otherAccordion) => {
            if (otherAccordion !== this) {
              otherAccordion.checked = false;
            }
          });
        }
      });
    });
  });
;
document.addEventListener('DOMContentLoaded', function () {
    var announcementBar = document.querySelector('.custom__announcement-bar');
    var headerSection = document.querySelector('.custom-header--section');

    if (headerSection) headerSection.style.top = `${announcementBar.clientHeight}px`;

    window.addEventListener('scroll', function () {
      var header = document.querySelector('header');
      var stickyPoint = header.offsetTop;

      if (window.scrollY > stickyPoint) {
        header.classList.add('is-sticky');
        headerSection.style.top = 0;
      } else {
        header.classList.remove('is-sticky');
        if (announcementBar) headerSection.style.top = `${announcementBar.clientHeight}px`;
      }
    });
  });
;
window.__pageflyProducts = window.__pageflyProducts || {};
	window.__pageflyProducts["15633332437365"] = {
		id: 15633332437365,
		handle: "the-golden-pill",
		title: "The Golden Pill Subscription",
		type: "",
		url: "\/products\/the-golden-pill",
		vendor: "Elle-Sera",
		variants: [{"id":56331032396149,"title":"Default Title","option1":"Default Title","option2":null,"option3":null,"sku":"WHITEBOX","requires_shipping":true,"taxable":false,"featured_image":null,"available":true,"name":"The Golden Pill Subscription","public_title":null,"options":["Default Title"],"price":4995,"weight":100,"compare_at_price":null,"inventory_management":"shopify","barcode":null,"requires_selling_plan":true,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":4995}],"price":4995,"compare_at_price":4995,"per_delivery_price":4995,"selling_plan_id":1486782657,"selling_plan_group_id":"d1c31b7d875f371afdda85ee0906e6c15aee403a"}],"quantity_rule":{"min":1,"max":null,"increment":1}}],
		options: ["Title"],
		media: [{"alt":null,"id":66494450991477,"position":1,"preview_image":{"aspect_ratio":1.0,"height":4500,"width":4501,"src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__1-BRAND_HOOK.jpg?v=1772640523"},"aspect_ratio":1.0,"height":4500,"media_type":"image","src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__1-BRAND_HOOK.jpg?v=1772640523","width":4501},{"alt":null,"id":66494450925941,"position":2,"preview_image":{"aspect_ratio":1.0,"height":4500,"width":4501,"src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__2-BENEFITS.jpg?v=1772640523"},"aspect_ratio":1.0,"height":4500,"media_type":"image","src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__2-BENEFITS.jpg?v=1772640523","width":4501},{"alt":null,"id":66494451089781,"position":3,"preview_image":{"aspect_ratio":1.0,"height":4500,"width":4500,"src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__4-INGREDIENTS.jpg?v=1772706671"},"aspect_ratio":1.0,"height":4500,"media_type":"image","src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__4-INGREDIENTS.jpg?v=1772706671","width":4500},{"alt":null,"id":66494450958709,"position":4,"preview_image":{"aspect_ratio":1.0,"height":4500,"width":4501,"src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__5-MONTLY_PLAN.jpg?v=1772706671"},"aspect_ratio":1.0,"height":4500,"media_type":"image","src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__5-MONTLY_PLAN.jpg?v=1772706671","width":4501},{"alt":null,"id":66494451024245,"position":5,"preview_image":{"aspect_ratio":1.0,"height":4500,"width":4501,"src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__6-STARTER_PLAN.jpg?v=1761213614"},"aspect_ratio":1.0,"height":4500,"media_type":"image","src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__6-STARTER_PLAN.jpg?v=1761213614","width":4501}],
		has_only_default_variant: true,
		options_with_values: [{"name":"Title","position":1,"values":["Default Title"]}],
		selected_variant: null,
		selected_or_first_available_variant: {"id":56331032396149,"title":"Default Title","option1":"Default Title","option2":null,"option3":null,"sku":"WHITEBOX","requires_shipping":true,"taxable":false,"featured_image":null,"available":true,"name":"The Golden Pill Subscription","public_title":null,"options":["Default Title"],"price":4995,"weight":100,"compare_at_price":null,"inventory_management":"shopify","barcode":null,"requires_selling_plan":true,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":4995}],"price":4995,"compare_at_price":4995,"per_delivery_price":4995,"selling_plan_id":1486782657,"selling_plan_group_id":"d1c31b7d875f371afdda85ee0906e6c15aee403a"}],"quantity_rule":{"min":1,"max":null,"increment":1}},
		tags: ["type:ES","variant:Subscribe","YGroup_Golden_Pill"],
		template_suffix: "pf-78bbff65",
		featured_image: "\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__1-BRAND_HOOK.jpg?v=1772640523",
		featured_media: {"alt":null,"id":66494450991477,"position":1,"preview_image":{"aspect_ratio":1.0,"height":4500,"width":4501,"src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__1-BRAND_HOOK.jpg?v=1772640523"},"aspect_ratio":1.0,"height":4500,"media_type":"image","src":"\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__1-BRAND_HOOK.jpg?v=1772640523","width":4501},
		images: ["\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__1-BRAND_HOOK.jpg?v=1772640523","#\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__2-BENEFITS.jpg?v=1772640523","#\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__4-INGREDIENTS.jpg?v=1772706671","#\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__5-MONTLY_PLAN.jpg?v=1772706671","\/\/elle-sera.com\/cdn\/shop\/files\/Elle_Sera_PDP__6-STARTER_PLAN.jpg?v=1761213614"],
		quantity: ["56331032396149:6990"]
	};
;
(function () {
  function injectSkioCSS() {
    const picker = document.querySelector('.pf-skio-wrap skio-plan-picker') || document.querySelector('skio-plan-picker');
    if (!picker || !picker.shadowRoot) return;

    if (picker.shadowRoot.getElementById('pf-skio-overrides')) return;

    const style = document.createElement('style');
    style.id = 'pf-skio-overrides';
    style.textContent = `
  /* ===== Layout / spacing ===== */
  
  .group-container {
    background-color: #D4B195 !important}

  .group-container--selected {
    background-color: #fff !important}

  .group-container--selected .skio-radio__container {
    color: #ab0001!important
    }

  .skio-radio__container {
    color: #1E1E1E!important
    }

  .group-label{
    padding: 20px !important;
    border-radius: 14px !important;
  }

  .group-topline{
    align-items: flex-start !important;
  }

  .group-title{
    font-size: 18px !important;
    font-weight: 400 !important;
  }

  .savings.bubble{
    display: none;
  }

  .group-content-additional{
    margin-top: 0px !important;}

  .skio-price {
    flex-wrap: nowrap !important;
    font-size: 18px !important;
    font-weight: 400 !important;
  }

  .skio-price s{
    font-size: 18px !important;
    opacity: .55 !important;
  }

  .skio-radio__container svg {
    width: 20px !important;
    height: 20px !important;
  }

  .group-container--selected .skio-price{
    color: #ab0001 !important; /* red current price */
    font-size: 18px !important;
  }

  .group-container--selected .skio-price s{
    color: #1E1E1E !important;
    opacity: .55 !important;
    margin-right: 10px !important;
    font-size: 18px !important;
  }

  .group-container {
      border-color: #fff !important;
  }

  .group-container--selected {
      border-color: #1E1E1E !important;
  }

  .pf-skio-bullets{
    margin: 10px 0 0 !important;
    padding: 0 !important;
    list-style: none !important;
  }

  .pf-skio-bullets li{
    position: relative !important;
    padding-left: 26px !important;
    margin: 4px 0 !important;
    font-size: 16px !important;
    line-height: 1.2 !important;
  }

  .pf-skio-bullets li::before{
    content: "" !important;
    position: absolute !important;
    left: 0 !important;
    top: 2px !important;
    width: 18px !important;
    height: 18px !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: contain !important;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 21 22' fill='none'><path d='M7.8 3.2C8.3 2.2 9.3 1.6 10.5 1.6c1.2 0 2.2.6 2.7 1.6.2.3.6.4.9.3 1-.3 2.2 0 3 .8.8.8 1.1 2 .8 3-.1.3 0 .7.3.9 1 .5 1.6 1.5 1.6 2.7 0 1.2-.6 2.2-1.6 2.7-.3.2-.4.6-.3.9.3 1-.0 2.2-.8 3-.8.8-2 .1-3 .0-.3-.1-.7 0-.9.3-.5 1-1.5 1.6-2.7 1.6-1.2 0-2.2-.6-2.7-1.6-.2-.3-.6-.4-.9-.3-1 .3-2.2 0-3-.8-.8-.8-1.1-2-.8-3 .1-.3 0-.7-.3-.9-1-.5-1.6-1.5-1.6-2.7 0-1.2.6-2.2 1.6-2.7.3-.2.4-.6.3-.9-.3-1 .0-2.2.8-3 .8-.8 2-.1 3-.0.3.1.7 0 .9-.3Z' stroke='%232A2827' stroke-width='1.5' fill='none'/><path d='M6.8 11.0l2.3 2.3 5.3-5.3' stroke='%232A2827' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  }
`;
    picker.shadowRoot.appendChild(style);
  }

  injectSkioCSS();
  document.addEventListener('DOMContentLoaded', injectSkioCSS);
  window.addEventListener('load', injectSkioCSS);
  setTimeout(injectSkioCSS, 300);
  setTimeout(injectSkioCSS, 800);
  setTimeout(injectSkioCSS, 1500);
})();
;
(function () {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP";

    function formatCurrency(value) {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }

    document.querySelectorAll(".pf-per-day").forEach(function (el) {
      var priceCents = parseInt(el.getAttribute("data-price"), 10);
      var days = parseFloat(el.getAttribute("data-days")) || 30;
      var perDay = (priceCents / 100) / days;

      el.textContent = formatCurrency(perDay) + "";
    });
  })();
;
(function () {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP";

    function formatCurrency(value) {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }

    document.querySelectorAll(".pf-per-day").forEach(function (el) {
      var priceCents = parseInt(el.getAttribute("data-price"), 10);
      var days = parseFloat(el.getAttribute("data-days")) || 30;
      var perDay = (priceCents / 100) / days;

      el.textContent = formatCurrency(perDay) + "";
    });
  })();
;
!function(){
      window.__pagefly_section_setting__ = {"pageTitle":"key products","pageType":"section","pageId":"514e66d5-e17e-449d-8681-962df424eb6e","lazyLoad":false,"forceByPassGoogleLightHouse":false,"imageLazyLoad":false,"nativeImageLazyLoad":true,"useThemeJQ":false,"sectionRootType":"FlexSection","trackingIDs":[]};
      window.__pagefly_setting__&&(window.__pagefly_setting2__=window.__pagefly_setting__),window.__pagefly_setting__={"baseURL":"https://apps.pagefly.io","analyticsURL":"https://analytics.pagefly.io","isBackend":false,"cdnURL":"https://cdn.pagefly.io","pageflyVersion":"4.26.3.5","shopDomain":"elle-sera.myshopify.com","elementData":{},"shopifyProxyPath":"/apps/pagefly"},window.__pagefly_setting2__&&(window.__pagefly_setting__=function _(d,b){let c={...d||{}};for(let a of Object.keys(b))b[a]instanceof Object&&(Array.isArray(b[a])&&c[a]?Object.assign(b[a],[...b[a],...c[a]]):Object.assign(b[a],_(c[a],b[a])));return Object.assign(c||{},b),c}(__pagefly_setting2__,__pagefly_setting__),delete window.__pagefly_setting2__),window.__pagefly_setting__.moneyFormat="£{{amount}}"}();
;
!function(){
      window.__pagefly_page_setting__ = {"pageTitle":"Golden Pill - Mobile Edits","pageType":"product","pageId":"78bbff65-fa2f-4490-89e6-58ad4ea9281a","lazyLoad":false,"forceByPassGoogleLightHouse":false,"imageLazyLoad":false,"nativeImageLazyLoad":true,"useThemeJQ":false,"sectionRootType":"FlexSection","trackingIDs":[]};
      window.__pagefly_setting__&&(window.__pagefly_setting2__=window.__pagefly_setting__),window.__pagefly_setting__={"baseURL":"https://apps.pagefly.io","analyticsURL":"https://analytics.pagefly.io","isBackend":false,"cdnURL":"https://cdn.pagefly.io","pageflyVersion":"4.26.3.18","shopDomain":"elle-sera.myshopify.com","elementData":{"pf-21_":{"hoverAction":0,"onHover":0,"clickAction":0,"navStyle":"nav-style-1","paginationStyle":"pagination-style-1","slidesToShow":{"all":1,"laptop":1,"tablet":1,"mobile":1},"slidesToScroll":{"all":1,"laptop":1,"tablet":1,"mobile":1},"loading":"lazy","disableSlideshow":false,"id":"a8926160-ef87-4dce-89bb-e9ab2f029675","_type":"MediaMain3"},"pf-22_":{"slidesToShow":{"all":5,"laptop":5,"tablet":5,"mobile":5},"slidesToScroll":{"all":1,"laptop":1,"tablet":1,"mobile":1},"displayPartialItems":{"all":true,"laptop":false,"tablet":false,"mobile":false},"navStyle":"none","listLayout":{"all":1,"laptop":1,"tablet":1,"mobile":1},"id":"a41d3f07-11da-410a-9243-c59bd90cf6f3","_type":"MediaList2"},"pf-24_":{"applyCondition":false,"collectionSource":"all","collectionIds":[],"tags":"","id":"5fed49cd-b532-482f-8eac-31efb5fe5498","_type":"ProductBadge"},"pf-20_":{"listPosition":{"all":3,"laptop":3,"tablet":2,"mobile":2},"hoverAction":0,"onHover":0,"clickAction":0,"imageSource":"featured","id":"b5b57dd0-6435-4ae3-b069-30ab9b889735","_type":"ProductMedia3"},"pf-25_":{"autoPlay":false,"autoPlayDelay":3000,"loop":true,"slidesToShow":{"all":1,"laptop":1,"tablet":1,"mobile":1},"slidesToScroll":{"all":1,"laptop":1,"tablet":1,"mobile":1},"displayPartialItems":{"all":false,"laptop":false,"tablet":true,"mobile":true},"gutter":{"all":0,"laptop":0,"tablet":10,"mobile":10},"maxHeight":true,"pauseOnHover":false,"navStyle":"nav-style-1","paginationStyle":"pagination-style-1","id":"739eed96-9545-4ddb-8c41-e3d5e2f89efd","_type":"Slideshow"},"pf-335_":{"autoPlay":false,"autoPlayDelay":3000,"loop":true,"slidesToShow":{"all":1,"laptop":1,"tablet":2,"mobile":1},"slidesToScroll":{"all":1,"laptop":1,"tablet":1,"mobile":1},"displayPartialItems":{"all":false,"laptop":false,"tablet":false,"mobile":true},"gutter":{"all":0,"laptop":0,"tablet":20,"mobile":20},"maxHeight":true,"pauseOnHover":false,"navStyle":"nav-style-1","paginationStyle":"none","id":"ae73228e-7b9c-42b8-9904-07efe93b4e41","_type":"Slideshow"},"pf-459_":{"autoPlay":false,"autoPlayDelay":3000,"loop":true,"slidesToShow":{"all":1,"laptop":1,"tablet":1,"mobile":1},"slidesToScroll":{"all":1,"laptop":1,"tablet":1,"mobile":1},"displayPartialItems":{"all":false,"laptop":false,"tablet":false,"mobile":true},"gutter":{"all":20,"laptop":20,"tablet":0,"mobile":0},"maxHeight":true,"pauseOnHover":false,"navStyle":"nav-style-1","paginationStyle":"none","id":"f73bb702-3ee2-4468-b857-3f6bc78c0a95","_type":"Slideshow"},"pf-562_":{"autoPlay":false,"autoPlayDelay":3000,"loop":true,"slidesToShow":{"all":1,"laptop":1,"tablet":1,"mobile":1},"slidesToScroll":{"all":1,"laptop":1,"tablet":1,"mobile":1},"displayPartialItems":{"all":false,"laptop":false,"tablet":false,"mobile":true},"gutter":{"all":20,"laptop":20,"tablet":0,"mobile":5},"maxHeight":true,"pauseOnHover":false,"navStyle":"nav-style-1","paginationStyle":"none","id":"aac77d9c-0833-46bf-b913-3e4c1c17d8a4","_type":"Slideshow"},"pf-785_":{"autoPlay":false,"autoPlayDelay":3000,"loop":false,"slidesToShow":{"all":1,"laptop":1,"tablet":1,"mobile":1},"slidesToScroll":{"all":1,"laptop":1,"tablet":1,"mobile":1},"displayPartialItems":{"all":false,"laptop":false,"tablet":true,"mobile":true},"gutter":{"all":0,"laptop":0,"tablet":20,"mobile":20},"maxHeight":true,"pauseOnHover":false,"navStyle":"none","paginationStyle":"pagination-style-1","id":"ce8d7d83-a21b-4f95-9844-94bb4d9bc1e9","_type":"Slideshow"}},"shopifyProxyPath":"/apps/pagefly"},window.__pagefly_setting2__&&(window.__pagefly_setting__=function _(d,b){let c={...d||{}};for(let a of Object.keys(b))b[a]instanceof Object&&(Array.isArray(b[a])&&c[a]?Object.assign(b[a],[...b[a],...c[a]]):Object.assign(b[a],_(c[a],b[a])));return Object.assign(c||{},b),c}(__pagefly_setting2__,__pagefly_setting__),delete window.__pagefly_setting2__),window.__pagefly_setting__.moneyFormat="£{{amount}}"}();
;
(function () {
  function init() {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return false;

    const $el = jQuery('.pf-logo-ticker');
    if (!$el.length) return false;

    $el.not('.slick-initialized').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 8000,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      swipeToSlide: true
    });

    return true;
  }

  let tries = 0;
  const t = setInterval(() => { tries++; if (init() || tries > 50) clearInterval(t); }, 100);
})();

document.querySelector('[name=id]').dispatchEvent(new Event('change'))
;
System.import('https://elle-sera.com/cdn/shop/t/57/assets/theme.nomoduled6ff.js?v=144834821819312224081759502047');
;
var _learnq = _learnq || [];
      var classname = document.getElementsByClassName('add-to-cart');
      var addToCart = function () {
        _learnq.push(['track', 'Added to Cart', item]);
      };
      for (var i = 0; i < classname.length; i++) {
        classname[i].addEventListener('click', addToCart, false);
      }
;
document.addEventListener("DOMContentLoaded", function () {
    console.log("just here");
    checkSlickLoaded();
  });

  function checkSlickLoaded() {
    if (typeof $.fn.slick === "function") {
      console.log("Slick is loaded");
      initializeSlick();
    } else {
      console.log("Slick not loaded yet. Retrying...");
      setTimeout(checkSlickLoaded, 100); // check again after 100ms
    }
  }

  function initializeSlick() {
    var slickElements = $(".thatworks-slides");
    slickElements.each(function () {
      var slickElement = $(this);
      var slickData = slickElement.attr("data-slick");
      if (!slickData) return;
      try {
        var slickSettings = JSON.parse(slickData.replace(/&quot;/g, '"'));
        if (!slickElement.hasClass("slick-initialized")) {
          slickElement.slick(slickSettings);
        }
      } catch (e) {
        console.error("Error parsing slick settings:", e);
      }
    });
  }
;
(() => {
  const ATC_FORM_SELECTOR = 'form[action*="/cart/add"]';
  const DRAWER_SECTION_ID = '0-cart-drawer';

  async function refreshDrawerAndOpen() {
    // 1) Fresh cart (cache-busted like your theme)
    const cart = await fetch('https://elle-sera.com/cart2a3b.js?r=' + Math.random(), { credentials: 'same-origin' }).then(r => r.json());

    // Update your custom header badge
    document.querySelectorAll('.custom-header__cart-counts span')
      .forEach(el => el.textContent = cart.item_count);

    // 2) Fetch the exact drawer section your theme uses
    const drawerHTML = await fetch('/?section_id=' + DRAWER_SECTION_ID + '&r=' + Math.random(), {
      credentials: 'same-origin'
    }).then(r => r.text());

    const tmp = document.createElement('div');
    tmp.innerHTML = drawerHTML;

    const newDrawer = tmp.querySelector('cart-drawer');
    const oldDrawer = document.querySelector('cart-drawer');

    if (newDrawer && oldDrawer) {
      // Replace the whole element (keeps behaviour cleaner than innerHTML)
      oldDrawer.replaceWith(newDrawer);

      // Keep count attribute in sync
      newDrawer.setAttribute('data-cart-count', String(cart.item_count));

      // Open
      if (typeof newDrawer.open === 'function') newDrawer.open();
      return true;
    }

    return false;
  }

  async function addAndOpen(form) {
    const fd = new FormData(form);

    const addRes = await fetch('https://elle-sera.com/cart/add.js', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });

    if (!addRes.ok) throw new Error('add failed');
    await addRes.json();

    const ok = await refreshDrawerAndOpen();
    if (!ok) window.location.href = 'https://elle-sera.com/cart';
  }

  // Intercept submit early so native redirect can’t win
  window.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches(ATC_FORM_SELECTOR)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    addAndOpen(form).catch(() => form.submit());
  }, true);

  // Also catch ATC clicks (PageFly sometimes bypasses submit)
  window.addEventListener('click', (e) => {
    const btn = e.target.closest('button[name="add"], input[type="submit"]');
    if (!btn) return;

    const form = btn.closest(ATC_FORM_SELECTOR);
    if (!form) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    addAndOpen(form).catch(() => form.submit());
  }, true);
})();
;
(() => {
  const BUNDLE_VARIANT_ID = 41765535744193;

  // Keep both selectors in case desktop/mobile use different ATC IDs
  const BTN_SEL = '#pf_atc, #pf_atc_mobile';
  const FORM_SEL = '#product_form_15667192267125';
  const DRAWER_SECTION_ID = '0-cart-drawer';

  function checkedValue(name) {
    const radios = Array.from(document.querySelectorAll(`input[name="${name}"]`));
    if (!radios.length) return null;

    // Prefer checked radio in the visible layout
    const visibleChecked = radios.find(r => r.checked && r.offsetParent !== null);
    if (visibleChecked) return visibleChecked.value;

    // Fallback to any checked radio
    const anyChecked = radios.find(r => r.checked);
    return anyChecked ? anyChecked.value : null;
  }

  function mode() {
    const mobileVal = checkedValue('pf_purchase_mode_mobile');
    const desktopVal = checkedValue('pf_purchase_mode');
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    return isMobile
      ? (mobileVal || desktopVal || 'skio')
      : (desktopVal || mobileVal || 'skio');
  }

  function getForm(btn) {
    return btn?.closest('form') ||
      document.querySelector(FORM_SEL) ||
      document.querySelector('form[action*="/cart/add"]');
  }

  async function refreshDrawerAndOpen() {
    // 1) Fresh cart
    const cart = await fetch('https://elle-sera.com/cart2a3b.js?r=' + Math.random(), { credentials: 'same-origin' })
      .then(r => r.json());

    // Update header badge
    document.querySelectorAll('.custom-header__cart-counts span')
      .forEach(el => el.textContent = cart.item_count);

    // 2) Refresh drawer section
    const drawerHTML = await fetch('/?section_id=' + DRAWER_SECTION_ID + '&r=' + Math.random(), {
      credentials: 'same-origin'
    }).then(r => r.text());

    const tmp = document.createElement('div');
    tmp.innerHTML = drawerHTML;

    const newDrawer = tmp.querySelector('cart-drawer');
    const oldDrawer = document.querySelector('cart-drawer');

    if (newDrawer && oldDrawer) {
      oldDrawer.replaceWith(newDrawer);
      newDrawer.setAttribute('data-cart-count', String(cart.item_count));
      if (typeof newDrawer.open === 'function') newDrawer.open();
      return true;
    }

    return false;
  }

  async function addBundleOnly() {
    const res = await fetch('https://elle-sera.com/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [{ id: BUNDLE_VARIANT_ID, quantity: 1 }] })
    });

    if (!res.ok) throw new Error('bundle add failed');
    await res.json();

    const ok = await refreshDrawerAndOpen();
    if (!ok) window.location.href = 'https://elle-sera.com/cart';
  }

  function setLoading(btn, isLoading) {
    if (!btn) return;
    btn.disabled = !!isLoading;
    btn.style.opacity = isLoading ? '0.7' : '';
    btn.style.pointerEvents = isLoading ? 'none' : '';
  }

  function bindOne(btn) {
    if (!btn) return;
    if (btn.dataset.pfBound === "1") return;
    btn.dataset.pfBound = "1";

    // Capture first, stop PageFly/default ATC
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();

      const form = getForm(btn);
      if (!form) return;

      try {
        setLoading(btn, true);

        if (mode() === 'bundle') {
          await addBundleOnly();
        } else {
          // Let Skio/current form handle normal add
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        }
      } catch (err) {
        console.error(err);
        alert('Could not add to cart.');
      } finally {
        setLoading(btn, false);
      }
    }, true);
  }

  function bind() {
    document.querySelectorAll(BTN_SEL).forEach(bindOne);
  }

  document.addEventListener('DOMContentLoaded', bind);
  window.addEventListener('load', bind);
  setTimeout(bind, 300);
  setTimeout(bind, 800);
  setTimeout(bind, 1500);
})();
;
// custom pf slider buttons js

  document.addEventListener('click', (e) => {
  const btn = e.target.closest('.my-slider-nav');
  if (!btn) return;

  const dir = btn.getAttribute('data-dir');
  const wrap = btn.closest('.my-slider-wrap');
  if (!wrap) return console.warn('No .my-slider-wrap around this nav + slider');

  const prev = wrap.querySelector('.pf-slider-prev');
  const next = wrap.querySelector('.pf-slider-next');

  (dir === 'prev' ? prev : next)?.click();
});